import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/about_sandbox.svg'
import _imports_1 from '@/assets/img/about_5g.svg'


const _withScopeId = n => (_pushScopeId("data-v-78d304b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", null, "ひろしまサンドボックスとは？")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "content-text" }, [
    /*#__PURE__*/_createTextVNode(" ひろしまサンドボックスは広島県が主催するAI/IoT実証プラットフォームです。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" AI/IoT、ビッグデータ等インダストリー4.0や次世代技術によってこれまでにない新しいソリューションを創り出し、技術やノウハウを持つ広島県内外の企業や人材を呼び込み、様々な産業・地域課題の解決をテーマとして、共創で試行錯誤できるオープンな実証実験の場を構築しています。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "content-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "ひろしまサンドボックス"
    })
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", null, "LOVE & PEACE LAB.とは？")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "content-text" }, [
    /*#__PURE__*/_createTextVNode(" NTTドコモ中国支社による、広島市中心部の5Gエリアを活用した企業向けの実証応援プロジェクトです。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 5Gエリアを実証実験エリア「5G LOVE & PEACE Lab.」として、NTTドコモが提供する「5G関連機器」アセット等の先進技術を地域企業へ提供し、広島の地域の課題の解決や広島発ソリューションの創出、広島の産業振興への貢献をめざします。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" NTTドコモ中国支社自身でも、プロジェクトの一つとして「5Gを使った先進的な教育とLOVE & PEACE」をテーマに本イベントを開催しました。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "content-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "5G LOVE&PEACE Lab."
    })
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "copy" }, "© NTT DOCOMO, INC. All Rights Reserved.", -1))
const _hoisted_8 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, _hoisted_8))
}